/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React, { useState } from 'react';
import { useViewRouterConfig } from '@routes/home/flavours/hooks/useViewRouterConfig';
import { useAppClickHandlers } from '@hooks/useAppClickHandlers';
import { useHomepageProductCards } from '@routes/home/flavours/hooks/useHomepageProductCards';
import { ProductCards } from '@routes/home/flavours/partials/ProductCards';
import DisambiguationModal, { DisambiguationModalProps } from '@routes/home/partials/DisambiguationModal';

interface SolutionsProps {
  heading: string;
}

const Solutions = (props: SolutionsProps) => {
  const { heading } = props;
  const [disambiguationModal, setDisambiguationModal] = useState<DisambiguationModalProps | undefined>(undefined);

  const { viewConfig } = useViewRouterConfig({ readOnly: true });
  const clickHandlers = useAppClickHandlers({ toggleRequestDemoModal: () => {}, setDisambiguationModal });
  const productCards = useHomepageProductCards({ view: viewConfig.view, clickHandlers });

  return (
    <>
      <h2 className='mb-4 strong'>{heading}</h2>
      <div>
        <ProductCards cards={productCards} showContactUs={true} clickHandlers={clickHandlers} />
      </div>
      {disambiguationModal ? <DisambiguationModal {...disambiguationModal} /> : null}
    </>
  );
};

export default Solutions;
